import { AfterViewInit, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import {
  AccountService,
  AlertService,
  CampaignProductService,
  CampaignService,
  CampaignTrackingService,
  CRMCampaignService,
  FunnelStepService,
  GatewayPerformanceReportService,
  GuiService,
  MerchantService,
  ReportsConfigService,
  StorageService,
  UserService,
  CancelReasonCategoryService,
} from '../_services';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { FunnelService } from '../_services/funnel.service';
import { ReportsAbstractV3Component } from './reports-abstract-v3.component';
import { MultiOptions } from '../custom-multi-select/multi-select';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { GatewayPerformanceFields, GatewayPerformanceFilters } from './utils/constants';
import { reportsFieldDataV3 } from './utils/reportsFieldData';
import { cloneDeep } from 'lodash';
import { ReportTypes, ReportVersion } from './models/reports';
import { expandCollapse } from '../_shared/animations/app-animations';

@Component({
  moduleId: module.id.toString(),
  selector: 'gateway-performance-report-v3',
  templateUrl: './templates/reports-v3.component.html',
  styleUrls: ['./styles/reports-v2.component.scss', './styles/reports-v3.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [expandCollapse],
})
export class GatewayPerformanceReportV3Component extends ReportsAbstractV3Component implements OnInit, AfterViewInit {
  fields: MultiOptions = cloneDeep(GatewayPerformanceFields);
  filters: MultiOptions = cloneDeep(GatewayPerformanceFilters);
  reportType = ReportTypes.GATEWAY_TRANSACTION;
  dropdownsLoading: boolean = false;
  showExcludeUpsellsFilter: boolean = false;
  showExcludeValidationsFilter: boolean = false;
  showOverviewPanel: boolean = true;
  showDriversPanel: boolean = true;
  fetchesFilterOptionsOnInit: boolean = false;

  predefinedFields = ['exclude_zeroes'];
  commonReportsFields = ['transactions', 'refunds_pending', 'approvals', 'declines', 'approved', 'approval_rate'];
  summaryFields = [];
  fieldsToExcludeFromReport: string[] = [];
  fieldsNotHavingEmptyValue = [];
  switchFilterKeyMapping = [];

  pctFieldMap: { [key: string]: string } = {
    approvals: 'approvals_pct',
    declines: 'declines_pct',
  };

  selectedDimensions = [
    { model: 'date', label: 'Date', selected: true, disabled: false },
  ];

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected alertService: AlertService,
    protected formBuilder: FormBuilder,
    public reportsService: GatewayPerformanceReportService,
    protected modalService: NgxSmartModalService,
    protected campaignService: CampaignService,
    protected reportsConfigService: ReportsConfigService,
    protected trackingSourceService: CampaignTrackingService,
    protected userService: UserService,
    protected accountService: AccountService,
    protected campaignProductService: CampaignProductService,
    protected crmCampaignService: CRMCampaignService,
    protected storageService: StorageService,
    protected stepService: FunnelStepService,
    protected merchantService: MerchantService,
    protected cancelReasonCategoryService: CancelReasonCategoryService,
    protected funnelService: FunnelService,
    protected guiService: GuiService
  ) {
    super(
      router,
      location,
      route,
      alertService,
      reportsService,
      campaignService,
      reportsConfigService,
      trackingSourceService,
      userService,
      accountService,
      campaignProductService,
      crmCampaignService,
      storageService,
      stepService,
      merchantService,
      modalService,
      cancelReasonCategoryService,
      funnelService,
      guiService
    );
    this.fieldData = reportsFieldDataV3;
    this.updatePreSelectedDimensions('date');
    this.bannerTitle = 'Gateway Performance Report';
    this.bannerSubtitle =
      'This report gives you an end-to-end view of payment performance, combining high-level summaries with flexible breakdowns and detailed analysis. It helps you quickly understand overall results and then drill into the specific factors driving approvals, declines, and revenue.';
  }

  protected initFromDashboardNav(dim: string) {
    super.initFromDashboardNav(dim);
    const f = this.storageService.get('gateway_dashboard_nav_filters');
    if (f) {
      if (f.start_date && f.end_date) {
        this.navStartDate = f.start_date;
        this.navEndDate = f.end_date;
      }
      if (f.merchant_id) {
        this.selectedGateway = f.merchant_id;
      }
      if (f.order_type) {
        this.selectedStage = f.order_type;
      }
      if (f.count_type) {
        this.countType = f.count_type;
      }
      this.storageService.remove('gateway_dashboard_nav_filters');
    }
  }

  ngOnInit() {
    super.ngOnInit();
    this.isGatewayTransactionReport = true;
  }

  ngAfterViewInit() {
    if (this.panel) {
      this.panel.expanded = false;
    }
    if (this.tablePanel) {
      this.tablePanel.expanded = true;
    }
  }

  drop(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.selectedDimensions, event.previousIndex, event.currentIndex);
  }

  getQueryForSummary() {
    const query = super.getQueryForSummary();
    query['report_type'] = this.reportType;
    query['report_version'] = ReportVersion.Clickhouse;
    return query;
  }

  getQueryForReport() {
    const query = super.getQueryForReport();
    const fieldsToStrip = this.commonReportsFields.concat(Object.values(this.pctFieldMap));
    query['report_type'] = this.reportType;
    query['report_version'] = ReportVersion.Clickhouse;
    query['show_percentage'] = this.showPercentage;
    query['fields'] = query['fields'].filter((f: string) => !fieldsToStrip.includes(f));
    return query;
  }
}
